import React from 'react';

const ArrowRightWhite = (props) => (
  <img
    {...props}
    src={`${MEDIA_ROOT}/icons/icn_arrowright_white.svg`}
    alt="Arrow right"
  />
);

export default ArrowRightWhite;
